<template>
  <div class="swiper">
    <div class="swiper__main-group"
         @mousedown="startDrag"
         @mousemove="drag"
         @mouseup="stopDrag"
         @touchmove="drag"
         @touchend="stopDrag"
         @touchstart="startDrag"
    >
      <div class="swiper__main-group_inner" :style="translate" :class="transition" ref="inner">
        <slot></slot>
      </div>
    </div>
    <div class="swiper__pagination m-0 mb-1" v-if="items.length > 0">
      <v-radio filled v-model="currItemIndex" v-for="(item, index) of items" :val="index" :key="'i-' + index" @input="onInput"></v-radio>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import getImg from '@/mixins/getImg'
import checkMobile from '@/mixins/checkMobile'
import vRadio from '@/ui/controls/vRadio'

import screen from '@/mixins/screen'

const getCursorX = (event) => {
  if (event.touches && event.touches.length) {
    // touch
    return event.touches[0].pageX
  }

  return event.pageX
}

const getCursorY = (event) => {
  if (event.touches && event.touches.length) {
    // touch
    return event.touches[0].pageY
  }

  return event.pageY
}

export default {
  name: 'v-gallery-desktop',
  data () {
    return {
      open: 0,
      localItemIndex: 0,
      dragging: false,
      cursorStartX: 0,
      cursorCurrentX: 0,
      cursorStartY: 0,
      cursorCurrentY: 0,
      cursorDifference: 0,
      animating: 0,

      observer: null,

      items: [],
      itemWidth: 0
    }
  },
  mixins: [getImg, checkMobile, screen],
  props: {
    activeItemIndex: {
      type: Number,
      default: null
    }
  },

  computed: {
    currItemIndex: {
      get () {
        if (this.value === null) {
          return this.localItemIndex
        }

        return this.activeItemIndex
      },

      set (val) {
        this.localItemIndex = +val
        this.$emit('change', +val)
      }
    },

    translate () {
      if (this.currItemIndex === 0) {
        return `transform: translateX(${0 - this.cursorDifference}%);`
      }

      return `transform: translateX(${0 - (90 * this.currItemIndex) - this.cursorDifference}%);`
    },
    transition () {
      if (this.animating) {
        return 'swiper__main-group_inner--transition'
      }

      return null
    }
  },
  methods: {
    onInput () {
      this.animating = true
      setTimeout(() => {
        this.animating = false
        this.cursorStartX = 0
        this.cursorCurrentX = 0
      }, 200)
    },
    startDrag (e) {
      this.dragging = true
      this.cursorStartX = getCursorX(e)
      this.cursorStartY = getCursorY(e)
      this.cursorCurrentY = this.cursorStartY
      this.cursorCurrentX = this.cursorStartX
    },
    drag (e) {
      if (!this.dragging) {
        // avoid updating if not dragging
        return
      }
      this.cursorCurrentY = getCursorY(e)
      this.cursorCurrentX = getCursorX(e)
    },
    stopDrag () {
      this.dragging = false
      if (this.cursorDifference > 20 && this.currItemIndex < this.items.length - 1) {
        this.animating = true
        this.cursorDifference = 0
        this.currItemIndex++
        setTimeout(() => {
          this.animating = false
          this.cursorStartX = 0
          this.cursorCurrentX = 0
        }, 200)
      } else if (this.cursorDifference < -20 && this.currItemIndex !== 0) {
        this.animating = true
        this.cursorDifference = 0
        this.currItemIndex--
        setTimeout(() => {
          this.animating = false
          this.cursorStartX = 0
          this.cursorCurrentX = 0
        }, 200)
      } else {
        this.animating = true
        this.cursorStartX = 0
        this.cursorCurrentX = 0
        setTimeout(() => {
          this.animating = false
          this.cursorStartX = 0
          this.cursorCurrentX = 0
        }, 200)
      }
    }
  },

  components: {
    vRadio
  },

  watch: {
    cursorCurrentX (newVal) {
      this.cursorDifference = (this.cursorStartX - newVal) / this.screen.width * 100
    }
  },

  mounted () {
    const el = this.$refs.inner
    this.items = [].slice.call(el.children)
    this.$nextTick(() => {
      setTimeout(() => {
        this.observer = new MutationObserver(items => {
          this.items = []
          const children = [].slice.call(el.children)
          children.forEach((element, index) => {
            Vue.set(this.items, index, element)
          })
          if (this.items.length) {
            this.itemWidth = this.items[0].clientWidth
          }
        })

        this.observer.observe(el, {
          childList: true,
          subtree: false,
          characterDataOldValue: false
        })
      }, 200)
    })

    if (this.items.length) {
      this.itemWidth = this.items[0].clientWidth
    }
  },

  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>

<style lang="scss">
.swiper {
  margin-left: -$default-spacing-mobile;
  margin-right: -$default-spacing-mobile;

  &__pagination {
    display: flex;
    justify-content: center;
  }

  &__main-group {
    align-self: flex-start;
    overflow-x: hidden;
    flex: 0 1 auto;
    position: relative;

    &_inner {
      display: flex;

      &--transition {
        transition: all .2s;
      }

      & > * {
        flex: 0 0 auto;
        width: 90%;

        padding-left: $default-spacing-mobile;

        &:last-child {
          //padding-right: $default-spacing-mobile;
        }
      }
    }
  }
}
</style>
